import * as Sentry from '@sentry/browser';

const apiHost = process.env.CLEARDATA_API_HOST;
export default async function logToDataDog(event) {
    try {
        const metrics = { events: [event] };

        fetch(`${apiHost}/metrics/v1/monitoring`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(metrics),
            credentials: 'omit',
        });
    } catch (error) {
        if (typeof window !== 'undefined') {
            const { SENTRY_DSN } = window && window.ZD ? window.ZD.configs : {};
            if (SENTRY_DSN) {
                Sentry.withScope(scope => {
                    scope.setExtras({
                        event,
                        message: 'error logging metric to data dog',
                    });
                    Sentry.captureException(error);
                });
            }
        }
    }
}
